import React from 'react';

import { computed } from 'mobx';
import { observer } from 'mobx-react';

import type { LookupResponse } from 'tm3-core/api.dtos';
import { cache } from 'tm3-core/cache';
import type ELookupNames from 'tm3-core/cache/stores/lookup-store/enums/lookup-names';

import type { IProps as SelectProps } from '../field-select';
import FieldSelect from '../field-select';

interface IProps extends Omit<SelectProps, 'items'> {
  items?: Partial<LookupResponse>[];
  lookup: ELookupNames;
}

export interface ILookupFieldSelectProps extends IProps {}

@observer
class LookupFieldSelect extends React.Component<IProps> {
  render() {
    return <FieldSelect {...this.props} items={this.items} />;
  }

  @computed
  private get items(): Partial<LookupResponse>[] {
    const { items, lookup, value } = this.props;
    const cacheItems = cache.lookups.GetLookups(lookup)?.values.map(
      (item: string, idx: number): Partial<LookupResponse> => ({
        id: idx,
        value: item,
        name: item
      })
    );

    if (!!value && !cacheItems?.find((item) => item.value === value)) {
      cacheItems?.push({
        id: cacheItems.length + 1,
        value: String(value),
        name: String(value)
      });
    }

    return cacheItems ?? items ?? [];
  }
}

export default LookupFieldSelect;
